var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.journey.teams,"label":"Team"},model:{value:(_vm.node.team),callback:function ($$v) {_vm.$set(_vm.node, "team", $$v)},expression:"node.team"}})}
var staticRenderFns = []

export { render, staticRenderFns }